export default ({ id, page }) => {
  const shields = {};

  for (const layoutId in page.layouts) {
    const layout = page.layouts[layoutId];
    for (const groupId in layout.groups) {
      const group = layout.groups[groupId];
      if (group.id === id) {
        for (const shieldId in group.shields) {
          const shield = group.shields[shieldId];
          shields[shieldId] = shield;
        }
      }
    }
  }

  return shields;
};